import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";

export default function AllAccessPassDialog({ open, onClose, onSubmit, storePrice, setStorePrice, storeType, setStoreType }) {
	return (
		<Dialog open={open} onClose={onClose} aria-labelledby="all-access-dialog-title" aria-describedby="all-access-dialog-description">
			<DialogTitle id="all-access-dialog-title">All Access Pass</DialogTitle>
			<DialogContent>
				<Grid container>
					<Grid item xs={12} sx={{ m: 0, p: 1 }}>
						<TextField
							id="storeprice"
							label="Store Price"
							fullWidth
							value={storePrice}
							variant="standard"
							onChange={(e) => setStorePrice(e.target.value)}
						/>
					</Grid>
					<Grid item xs={12} sx={{ m: 0, p: 1 }}>
						<FormControl fullWidth variant="standard">
							<InputLabel id="store-select-label">Store</InputLabel>
							<Select labelId="store-select-label" id="store-select" value={storeType} onChange={(e) => setStoreType(e.target.value)}>
								<MenuItem value="Apple">Apple</MenuItem>
								<MenuItem value="Google">Google</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button onClick={onSubmit} autoFocus>
					Add
				</Button>
			</DialogActions>
		</Dialog>
	);
}
